import {AuthModel} from './_models'
import {staffCan} from './staffAccess'

type SmsLogAccess = Partial<Pick<AuthModel, 'rl' | 'staff'>>

// The SMS send log exposes every recipient number in the system, so it is limited to staff granted «پیامک»
// in the CRM, matching SmsLogQueryPolicy on the backend; the gateway settings need «مدیریت».
export const canViewSmsLog = (user?: SmsLogAccess | null): boolean => staffCan(user, 'sms')

export const canManageSmsSettings = (user?: SmsLogAccess | null): boolean =>
  staffCan(user, 'sms', 'manage')
